exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CirclesBar-module__wrapper___3TFkY{position:relative;display:grid;grid-auto-flow:column;background-color:#181818;border-radius:15px;gap:1em;padding:1em;overflow:hidden}.CirclesBar-module__wrapper___3TFkY div{z-index:2}", ""]);

// exports
exports.locals = {
	"wrapper": "CirclesBar-module__wrapper___3TFkY"
};